module.exports = __webpack_public_path__ + "static/media/totoro-loc.710e1c8f.JPG";